/* Native scrolling shared by mobile sections and Blocks' horizontal layout. */
(() => {
  if (window.xmilesMobileCarousels) return;
  window.xmilesMobileCarousels = true;
  const selector = '[data-xm-mobile-carousel]';
  const instances = new Map();
  const mobile = window.matchMedia('(max-width: 900px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function roots(scope) {
    return [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  }

  function init(scope) {
    roots(scope).forEach(root => {
      if (instances.has(root)) return;
      const track = root.querySelector('[data-xm-mobile-track]');
      const controls = root.querySelector('[data-xm-mobile-controls]');
      const previous = root.querySelector('[data-xm-mobile-prev]');
      const next = root.querySelector('[data-xm-mobile-next]');
      const position = root.querySelector('[data-xm-mobile-position]');
      if (!track || !controls || !previous || !next || !position) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let frame;
      let enabled = false;

      function items() { return Array.from(track.children); }
      function offsets() {
        const left = track.getBoundingClientRect().left;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        return items().map(item => Math.max(0, Math.min(max, item.getBoundingClientRect().left - left + track.scrollLeft)));
      }
      function currentIndex() {
        const points = offsets();
        return points.reduce((nearest, value, index) => Math.abs(value - track.scrollLeft) < Math.abs(points[nearest] - track.scrollLeft) ? index : nearest, 0);
      }
      function update() {
        enabled = (mobile.matches || root.hasAttribute('data-xm-carousel-desktop')) && items().length > 1 && track.scrollWidth > track.clientWidth + 1;
        controls.hidden = !enabled;
        track.tabIndex = enabled ? 0 : -1;
        if (!enabled) {
          track.scrollLeft = 0;
          return;
        }
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        const label = `${currentIndex() + 1} / ${items().length}`;
        if (position.textContent !== label) position.textContent = label;
      }
      function schedule() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }
      function go(index, instant = false) {
        if (!enabled) return;
        const points = offsets();
        track.scrollTo({ left: points[Math.max(0, Math.min(points.length - 1, index))], behavior: instant || reducedMotion.matches ? 'instant' : 'smooth' });
      }
      previous.addEventListener('click', () => go(currentIndex() - 1), options);
      next.addEventListener('click', () => go(currentIndex() + 1), options);
      track.addEventListener('scroll', schedule, { ...options, passive: true });
      track.addEventListener('keydown', event => {
        if (!enabled || event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') go(0);
        else if (event.key === 'End') go(items().length - 1);
        else go(currentIndex() + (event.key === 'ArrowLeft' ? -1 : 1));
      }, options);
      const observer = new ResizeObserver(schedule);
      observer.observe(track);
      instances.set(root, {
        update,
        select(target) { go(items().findIndex(item => item === target || item.contains(target)), true); },
        destroy() { controller.abort(); observer.disconnect(); cancelAnimationFrame(frame); }
      });
      update();
    });
  }

  mobile.addEventListener('change', () => instances.forEach(instance => instance.update()));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => roots(event.target).forEach(root => {
    instances.get(root)?.destroy();
    instances.delete(root);
  }));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest?.(selector);
    if (root) instances.get(root)?.select(event.target);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
